import React from "react";
import { Compass, Code2, Gauge, Sparkles, Layers, Shield } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../Reveal";

const features = [
  {
    icon: Compass,
    title: "Strategy",
    desc: "Positioning, user research, and product roadmaps that kill ambiguity before a single pixel is drawn.",
  },
  {
    icon: Sparkles,
    title: "Design",
    desc: "Interface design with opinion. Typography that earns its space. Motion that serves meaning.",
  },
  {
    icon: Code2,
    title: "Engineering",
    desc: "iOS, Android and cross-platform builds with a bias for speed, stability, and shippable code.",
  },
  {
    icon: Gauge,
    title: "Performance",
    desc: "Every frame, every byte, every millisecond audited. Fast is a feature.",
  },
  {
    icon: Layers,
    title: "Systems",
    desc: "Design systems and component libraries that scale with your team and product.",
  },
  {
    icon: Shield,
    title: "Care",
    desc: "Post-launch support, monitoring, and iteration. We don't disappear after 1.0.",
  },
];

function Features() {
  return (
    <section id="features" className="section relative bg-levi-bg">
      <div className="container-xl">
        <Reveal className="max-w-2xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-levi-primary" />
            <span className="eyebrow">What We Do</span>
          </div>
          <h2 className="display-lg text-levi-text">
            Six disciplines. <br />
            <span className="text-levi-primary">One standard.</span>
          </h2>
          <p className="mt-6 text-lg text-levi-muted max-w-xl">
            A tightly-coupled practice spanning strategy, design, and engineering — built to deliver
            work that survives real use.
          </p>
        </Reveal>

        <Stagger className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-levi-border">
          {features.map(({ icon: Icon, title, desc }, i) => (
            <StaggerItem key={title} className="group">
              <div className="h-full p-8 md:p-10 bg-levi-bg hover:bg-levi-surface transition-colors duration-500 cursor-default">
                <div className="flex items-start justify-between mb-8">
                  <div className="p-3 bg-levi-elevated border border-levi-border group-hover:border-levi-primary transition-colors duration-500">
                    <Icon size={22} className="text-levi-primary" />
                  </div>
                  <span className="font-mono text-xs text-levi-subtle">0{i + 1}</span>
                </div>
                <h3 className="font-display text-2xl tracking-widest uppercase text-levi-text mb-3">
                  {title}
                </h3>
                <p className="text-levi-muted leading-relaxed">{desc}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}

export default Features;
